<div class="encryption-entity-logs">
    <h5 class="encryption-entity-logs__title">{{'ENCRYPTION.TAB_ENTITIES' | translate}}</h5>

    <bzg-message class="" [showCloseBtn]="false" [status]="'info'">
        <div class="encryption-entity-logs__container">
            <div class="">{{'ENCRYPTION.DESCRIPTION_ENTITIES' | translate}}</div>

            <bzg-switch class="encryption-entity-logs__switch" 
                [ngClass]="{'encryption-entity-logs__switch--disabled': !enableEntityLogs}"
                [ngModel]="enableEntityLogs"
                (change)="onChangeEntityLogs($event)"
                [disabled]="isLoading">
            </bzg-switch>
        </div>
    </bzg-message>
</div>